import React from "react"
import { Icon } from "@blueprintjs/core"
import { IconNames } from "@blueprintjs/icons"
import BackgroundImage from "gatsby-background-image"
import { BaseBlockContent2 } from "@utils/richTextS"
import { getImage } from "gatsby-plugin-image"
import { convertToBgImage } from "gbimage-bridge"

const Hero = ({ sanityPages }) => {
  const image = convertToBgImage(getImage(sanityPages.hero?.heroBackground?.image?.asset?.gatsbyImageData))

  return (
    <BackgroundImage
      Tag="div"
      className="our-methods"
      {...image}
      alt={sanityPages.hero?.heroBackground?.image?.asset?.description}
    >
      <div className="our-methods-hero">
        {sanityPages.hero?.overline && (
          <p className="our-methods-overline">{sanityPages.hero?.overline}</p>
        )}
        {sanityPages.hero?.headline && (
          <h1 className="our-methods-headline">{sanityPages.hero?.headline}</h1>
        )}
        {sanityPages.hero?._rawSubheadline && (
          <BaseBlockContent2
            blocks={sanityPages.hero?._rawSubheadline}
            className="our-methods-description"
          />
        )}
        <Icon icon={IconNames.ARROW_DOWN} color="white" iconSize={40} />
      </div>
    </BackgroundImage>
  )
}

export default Hero
